import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Link, Hidden } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import error, { errorProps } from 'aurora-utils/error';
import Loading from 'aurora-components/Loading';
import { keyEmptyCheck, taskHandler } from 'aurora-utils/utils';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { CleverTapHomePageTasksSeeAll } from 'aurora-utils/cleverTap.eventhelper';
import { EmptyTask, ADGMImage } from 'aurora-components';
import styles from './styles';
const useStyles = makeStyles(styles);

const TasksList = ({ tasks, loading, failure, tasksTotal, handleClose }) => {
  const classes = useStyles();
  if (loading) {
    return <Loading />;
  }
  if (!loading && !tasks && failure.statusCode && failure.message) {
    return <Alert severity='error'>{keyEmptyCheck(failure.message)}</Alert>;
  }

  return (
    <div className={classes.notificationArea}>
      {tasks ? (
        <>
          <div className={classes.notificationbar}>
            <FormattedMessage {...messages.task_notification} values={{ s: `${tasksTotal}` }} />
            {/* <Hidden smDown> */}
              <ADGMImage onClick={handleClose} name='cross_black.svg' />
            {/* </Hidden> */}
          </div>

          <div className={classes.notificationDetailArea}>
            {tasks &&
              tasks.map((task, index) => {
                return (
                  <div
                    className={classes.applicationContent}
                    key={`task_${index + 1}`}
                    onClick={() => {
                      taskHandler(task);
                    }}
                    aria-hidden
                  >
                    <Grid container alignItems='center'>
                      <Grid item xs={7}>
                        <Typography component='h3' className={classes.subTitlethree}>
                          {keyEmptyCheck(task?.applicationType)}
                        </Typography>
                      </Grid>
                      <Grid item xs={5} className={classes.alignRight}>
                        {keyEmptyCheck(task?.status)}
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
          </div>
          <div className={classes.checkallLinkMain}>
            <Link
              href='/app/applications?page=1&type=tasks'
              className={classes.checkallLink}
              onClick={() => CleverTapHomePageTasksSeeAll()}
            >
              {keyEmptyCheck('see_all_tasks')}
            </Link>
          </div>
        </>
      ) : (
        <EmptyTask />
      )}
    </div>
  );
};

TasksList.propTypes = {
  tasks: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  failure: errorProps,
  tasksTotal: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
};

TasksList.defaultProps = {
  failure: error,
};

export default TasksList;
